// 品类、属性信息（产品/材料/模块共用）
import { productMenuIcon } from '@/assets/js/dict'

const state = {
  // 所有产品品类
  productClassifications: [],
}
const getters = {
  productClassifications: (state) => state.productClassifications,
  // 产品库菜单
  productClassificationMenu: (state) => {
    const commonClassification = state.productClassifications.filter((item) => {
      const configItemValue = item.configItemValues || []
      // 筛选出选型启用为true的产品品类
      return configItemValue.some((it) => it.code === 'isSelectionEnable' && it.value === 'true')
    })
    return commonClassification.map((item) => {
      const configItemValue = item.configItemValues || []
      const isNew = configItemValue.find((c) => c.code === 'isNew' && c.value === 'true')
      return {
        code: item.code,
        name: item.name,
        icon: productMenuIcon[item.code],
        isNew: !!isNew
      }
    })
  },
}
const mutations = {
  setProductClassifications(state, data) {
    state.productClassifications = data
  },
}
const actions = {
  // 获取所有产品品类
  async loadProductClassifications({ commit }, payload = {}) {
    try {
      const query = {
        resourceType: 'PRODUCT',
        ...payload
      }
      const data = await this.$api.classification.getClassification(query)
      commit('setProductClassifications', data || [])
    } catch (error) {
      commit('setProductClassifications', [])
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
